/*
 * Server-side score verification. A submitted run is nothing but the seed it
 * was played on and the ticks at which the player turned, so the node replays
 * it through the very same logic the browser ran and reads the score off the
 * result. Nothing the client claims about its score is trusted.
 */
// The lite bundler removes module web/ directories but scans root JavaScript
// files. Resolve the game core only in Node so this verifier stays server-only.
var _eval = eval('require')('./web/game'),
  createGame = _eval.createGame,
  setDirection = _eval.setDirection,
  step = _eval.step;
var crypto = eval('require')('crypto');
var shared = require('./shared');
var GRID_SIZE = 20;
var DIRECTIONS = {
  U: 'up',
  D: 'down',
  L: 'left',
  R: 'right'
};
function verifyRun(run) {
  var replay = shared.normalizeReplay(run);
  if (!replay) {
    return null;
  }
  run = replay.run;
  var parsedTurns = shared.parseTurns(run.turns, run.steps);
  var turns = parsedTurns && parsedTurns.map(function (turn) {
    return {
      step: turn.step,
      direction: DIRECTIONS[turn.direction]
    };
  });
  if (!turns) {
    return null;
  }
  var game = createGame({
    width: GRID_SIZE,
    height: GRID_SIZE,
    seed: run.seed
  });
  var turnIndex = 0;
  for (var tick = 0; tick < run.steps; tick++) {
    if (!game.alive || game.won) {
      return null;
    }
    if (turnIndex < turns.length && turns[turnIndex].step === tick) {
      setDirection(game, turns[turnIndex].direction);
      turnIndex += 1;
    }
    step(game);
  }
  if (game.alive && !game.won) {
    return null;
  }
  return {
    score: game.score,
    eaten: game.eaten,
    won: game.won
  };
}
function fingerprintReplay(replay) {
  var serialized = shared.serializeReplay(replay);
  if (!serialized) {
    return null;
  }
  return crypto.createHash('sha256').update(serialized, 'utf8').digest('hex');
}
module.exports = {
  sanitizeName: shared.sanitizeName,
  parseTurns: function parseTurns(value, totalSteps) {
    var turns = shared.parseTurns(value, totalSteps);
    return turns && turns.map(function (turn) {
      return {
        step: turn.step,
        direction: DIRECTIONS[turn.direction]
      };
    });
  },
  verifyRun: verifyRun,
  fingerprintReplay: fingerprintReplay
};